var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Chart',{attrs:{"width":"250px","height":"250px","option":_vm.storeManager}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }